import { Component, Host, Prop, Watch, h } from '@stencil/core';
import { getAssetSrc } from '../../helpers/helpers';
import type {
  ServiceTeaser,
  ServiceTeaserImage,
} from '../../helpers/utils/teaser-types';
@Component({
  tag: 'cms-service-teaser',
  styleUrl: 'cms-service-teaser.scss',
  shadow: true,
})
export class CmsServiceTeaser {
  private readonly bgImage = 'infobox-bg.svg';
  private serviceTeaserList: ServiceTeaser[];

  /**
   * set the service teaser data
   */
  @Prop() serviceTeasers: ServiceTeaser | string;

  /**
   * is true in cms preview mode
   */
  @Prop() isPreview: boolean;

  @Watch('serviceTeasers')
  private teasersWatcher(newValue: ServiceTeaser | string) {
    if (!newValue) return;
    this.serviceTeaserList =
      typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
  }

  private renderImage(images: ServiceTeaserImage, altTitleText: string) {
    return (
      <picture class='image-wrapper'>
        <source type='image/webp' srcSet={`${images.bp120} 120w`} />
        <img
          loading='lazy'
          alt={altTitleText}
          title={altTitleText}
          class='icon-image'
          src={images.jpgDefault}
          width='120'
          height='80'
        />
      </picture>
    );
  }

  private renderErrorMassage(massage: string) {
    return (
      <li key={massage} class='error-massage service-teaser'>
        {massage}
      </li>
    );
  }

  private renderTeaserHtml() {
    if (!this.serviceTeaserList?.length) return;

    return this.serviceTeaserList.map(
      ({
        teaserText,
        targetUrl,
        targetFrame,
        altTitleText,
        images,
        errorMassage,
      }) => {
        if (this.isPreview && errorMassage) {
          return this.renderErrorMassage(errorMassage);
        }

        if (!errorMassage) {
          return (
            <li
              key={teaserText}
              class='service-teaser'
              style={{
                webkitMaskImage: `url(${getAssetSrc(this.bgImage)})`,
                maskImage: `url(${getAssetSrc(this.bgImage)})`,
              }}
            >
              <a
                class={'teaser-link'}
                href={targetUrl}
                target={targetFrame}
                title={altTitleText}
              >
                <div class='service-icon-wrapper'>
                  {this.renderImage(images, altTitleText)}
                </div>
                <div class='text-wrapper' innerHTML={teaserText} />
                <div class={'icon-wrapper'}>
                  <cms-icon
                    size='xl'
                    color-token='--cms-theme-svg-color-on-background'
                    icon='arrowRight'
                  />
                </div>
              </a>
            </li>
          );
        }
      },
    );
  }

  connectedCallback() {
    if (!this.serviceTeasers) return;
    this.teasersWatcher(this.serviceTeasers);
  }

  render() {
    return (
      <Host>
        <ul class={'host-inner'}>{this.renderTeaserHtml()}</ul>
      </Host>
    );
  }
}
